import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=4aae1b94"
import script from "./SystemInfo.vue?vue&type=script&lang=js"
export * from "./SystemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aae1b94')) {
      api.createRecord('4aae1b94', component.options)
    } else {
      api.reload('4aae1b94', component.options)
    }
    module.hot.accept("./SystemInfo.vue?vue&type=template&id=4aae1b94", function () {
      api.rerender('4aae1b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/monitor/SystemInfo.vue"
export default component.exports